<template>
  <nav class="flex justify-center py-10">
    <div class="line"></div>
    <ul>
      <li class="active">
        <router-link to="/">Home</router-link>
      </li>
      <li>
        <a
          target="_black"
          href="https://drive.google.com/file/d/1ogLIyJyVpLSCpjovSe3fkoV7Xu5DTvW1/view?usp=sharing"
          >Get a copy of my CV
        </a>
      </li>
      <li>
        <router-link to="timeline">timeline</router-link>
      </li>
      <!-- <li>
        <router-link to="playground">_playGround</router-link>
      </li> -->
    </ul>
  </nav>
</template>

<script lang="ts">
import { Vue } from "vue-class-component";
export default class NavLink extends Vue {}
</script>

<style lang="scss" scoped>
nav {
  position: relative;
  .line {
    height: 2px;
    position: absolute;
    bottom: 0;
    margin: 10px 0 0 0;
    background: #ff1847;
  }
  ul {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    li {
      margin: 0 40px 0 0;
      transition: all 0.4s ease;
      a {
        opacity: 0.4;
        &:hover {
          opacity: 0.7;
        }
      }
      &:last-child {
        margin-right: 0;
      }
      a {
        text-decoration: none;
        text-transform: uppercase;
        display: block;
        font-weight: 600;
        letter-spacing: 0.2em;
        font-size: 14px;
      }
    }
  }
}
.router-link-active.router-link-exact-active {
  opacity: 1;
}
</style>
